export const nl = {
    send: 'Versturen',
    yes: 'Ja.',
    birthdate: 'Geboortedatum',
    chooseStore: 'Kies je winkel',
    city: 'Plaats',
    dateFormat: 'dd-mm-jjjj',
    disclaimer:
        'Door het invullen van dit formulier ga ik akkoord met de <2>Algemene Voorwaarden</2> en de <6>Privacy Statement</6>.',
    email: 'E-mailadres',
    firstName: 'Voornaam',
    houseNumber: 'Huisnummer (+ busnummer)',
    lastName: 'Achternaam',
    lastNamePrefix: 'Tussenvoegsel',
    mr: 'Dhr.',
    mrs: 'Mevr.',
    oldAddress: 'Oud adres',
    newAddress: 'Nieuw adres',
    postService: 'Maak je gebruik van het contactlenzenabonnement?',
    phoneNumber: 'Telefoonnummer',
    salutation: 'Aanhef',
    street: 'Straat',
    zipcode: 'Postcode',
    relocationDate: 'Verhuisdatum',
    requiredFootnote: 'Verplicht in te vullen',
    somethingWentWrong: 'Er is iets misgegaan bij het verzenden',
    yourInfo: 'Je gegevens',
    yourStores: 'Bij welke Pearle winkel(s) ben je klant?',
    validation: {
        date: 'Vul een datum in',
        dateNotValid: 'Geen geldige datum',
        city: 'Vul de plaatsnaam in',
        email: 'Vul een e-mailadres in',
        emailNotValid: 'Geen geldig e-mailadres',
        firstName: 'Vul een voornaam in',
        houseNumber: 'Vul het huisnummer in',
        lastName: 'Vul een achternaam in',
        phone: 'Vul een telefoonnummer in',
        phoneNotValid: 'Geen geldig telefoonnummer',
        store: 'Kies een winkel',
        street: 'Vul een straatnaam in',
        yourMessage: 'Vul je bericht in',
        zipcode: 'Vul de postcode in',
    },
};
